import React, { ReactNode } from 'react';
import { cn } from '@/shared/utils/shadcn';

const QAItem = ({
  className,
  question,
  answer,
  specialAnswer,
  index,
}: {
  className?: string;
  question: string;
  answer?: string;
  index: number;
  specialAnswer?: ReactNode;
}) => {
  return (
    <div className={cn('box-border w-full rounded-[10px] bg-white p-[1.716vw]', className)}>
      <div className="mb-[0.936vw]">
        <span className="text-[1.04vw] font-semibold leading-[1.04vw] text-[#8934D0]">Q{index + 1}: </span>
        <span className="text-[0.936vw] font-semibold leading-[0.936vw] text-[#111111]">{question}</span>
      </div>
      <div className="text-[0.832vw] text-[#666666]">{answer || specialAnswer}</div>
    </div>
  );
};

export default QAItem;
